export default __webpack_public_path__ + "static/media/email_broadcast.80eae097.png";